import { useEffect } from 'react';

export const useEmitPushHistory = (pathname: string) => {
  useEffect(() => {
    window.parent.postMessage({ action: 'pushHistory', path: pathname }, '*');
  }, [pathname]);
};
